'use strict';

module.exports = {
    UNAVIALABLE_SERVICE: 'Service is currently unavailable, please try again later.',
    NEED_ACTIVE: 'Your account {{account}} is using this website for the first time. Please {{activeLink}} to complete the activation and return to this page to continue operations.',
    GOTO_ACTIVE: 'Activate now',
    NOT_ACTIVED: 'The account has not been successfully activated, please {{activeLink}} to complete the activation.',
    COMPLETE_ACTIVE: 'Confirm activation',
    FORBID_ACTIVE: 'The account is not supported in AliExpress!',
    SIGN_UP_WITH_ANOTHER_ACCOUNT: 'Please log in with another account',
    ACTIVE_PAGE: 'Visit the account activation page'
};